import React from "react"
import { useLocation, useNavigate } from "react-router-dom"
import Tab from "@mui/material/Tab"
import TabContext from "@mui/lab/TabContext"
import TabList from "@mui/lab/TabList"
import TabPanel from "@mui/lab/TabPanel"
import Box from "@mui/material/Box"
import PageHeading from "components/common/LayoutComponents/PageHeading"
import PageContent from "components/common/LayoutComponents/PageContent"
import AiReview from "components/Pages/AiReview/AiReview"
import McpUsers from "components/Pages/McpUsers"
import McpAuditLog from "components/Pages/McpUsers/McpAuditLog"
import { McpPlatformWrapper } from "./McpPlatform.style"

const TAB_PATHS = {
  review: "/mcp-platform/review",
  users: "/mcp-platform/users",
  audit: "/mcp-platform/audit",
}

const pathToTab = (pathname) => {
  const path = pathname.toLowerCase()
  if (path.includes("/users")) return "users"
  if (path.includes("/audit")) return "audit"
  return "review"
}

const McpPlatform = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const activeTab = pathToTab(location.pathname)

  const handleTabChange = (_event, newValue) => {
    navigate(TAB_PATHS[newValue] || TAB_PATHS.review)
  }

  return (
    <PageContent>
      <McpPlatformWrapper>
        <PageHeading>
          <div className="heading-copy">
            <h1 className="page-title">MCP Platform</h1>
            <p className="page-subtitle">
              Review AI-proposed changes, manage MCP service accounts, and inspect audit history
            </p>
          </div>
        </PageHeading>

        <div className="tabs-shell">
          <TabContext value={activeTab}>
            <Box className="tabs-head">
              <TabList onChange={handleTabChange} aria-label="MCP platform sections">
                <Tab label="Review Queue" value="review" />
                <Tab label="MCP Users" value="users" />
                <Tab label="Audit Log" value="audit" />
              </TabList>
            </Box>
            <TabPanel className="tab-panel" value="review">
              <AiReview embedded />
            </TabPanel>
            <TabPanel className="tab-panel" value="users">
              <McpUsers embedded />
            </TabPanel>
            <TabPanel className="tab-panel" value="audit">
              <McpAuditLog embedded />
            </TabPanel>
          </TabContext>
        </div>
      </McpPlatformWrapper>
    </PageContent>
  )
}

export default McpPlatform
